import { Typography } from '@mui/material';

import styles from './DispatchedTypography.module.scss';

const DispatchedTypography = () => <Typography className={styles.label}>Dispatched</Typography>;

export default DispatchedTypography;
